import './App.css';
import { useEffect, useState } from 'react';
import WineLogo from './images/vara-logo.png';
import Flave from './images/grape.png';
import Footer from './components/Footer';
import Share from './images/share-icon.png';
import QR from './images/qr-icon.png';
import ShareMenu from './components/ShareMenu'
import { Helmet } from 'react-helmet';
import './fonts.css'
import Close from './images/close.png'
import Wine from './components/Wine';
import Beer from './components/Beer'; 
import Sparkling from './components/Sparkling'; // Import Sparkling component



function App() {

  const [tastingType, setTastingType] = useState(''); // Default to wine, can be changed to beer or sparkling
  const [tastingNotes, setTastingNotes] = useState({});
  const [wineID, setWineID] = useState(null);
  const [wineData, setWineData] = useState({});
  // Use this data to render user flavors and images. 
  const [userFlavorData, setUserFlavorData] = useState({});

  // User tasting data: sweetness and acidity percentages - Data used in My Tasting Profile
  const [userAcidity, setUserAcidity] = useState();
  const [userSweetness, setUserSweetness] = useState();

  //Wine Profile data
  const [wineProfileData, setWineProfileData] = useState({});

  // Wine Flavors Data used in the wine section
  const [wineFlavors, setWineFlavors] = useState({});

  const [wineAcidity, setWineAcidity] = useState();
  const [wineSweetness, setWineSweetness] = useState();

  // QR Code Data
  const [qrData, setQRData] = useState();
  const [iconQRIMGID, setIconQRIMGID] = useState([]);

  // Winery logo
  const [wineryLogo, setWineryLogo] = useState();

  //user tasting profile match and text
  const [matches, setMatches] = useState();
  const [tastingText, setTastingText] = useState({})

  const [theme, setTheme] = useState();
  const [headerText, setHeaderText] = useState();
  const [bodyText, setBodyText] = useState();

  const [isJustLoaded, setIsJustLoaded] = useState(true);

  // DATA NOT RENDERED IN HTML- State IDS for fetching relational fields
  const [relationalQrIDS, setRelationalQrIDS] = useState()
  const [wineProfileID, setWineProfileID] = useState(null);
  const [userRelationalFlavorIDS, setUserRelationalFlavorIDS] = useState([])
  const [relationalFlavorsData, setRelationalFlavorsData] = useState({})
  const [userFlavorIDS, setUserFlavorIDS] = useState()
  const [loading, setLoading] = useState(true);
  const [wineLoading, setWineLoading] = useState(false);
  const [error, setError] = useState(null);


  //State for opening and closing share menu
  const [menuOpen, setMenuOpen] = useState(false)
  const [shouldRender, setShouldRender] = useState(false);

  const imageBase = process.env.REACT_APP_IMAGE_ENDPOINT
  const imageType = process.env.REACT_APP_IMAGE_TYPE
  
  
  //Sparkling Data
  const [sparklingData, setSparklingData] = useState({});
  const [sparklingOwner, setSparklingOwner] = useState();
  const [sparklingTheme, setSparklingTheme] = useState();
  const [userSparklingFlavor, setUserSparklingFlavor] = useState([]);
  const [effervescence, setEffervescence] = useState();
  const [sparklingWineProfile, setSparklingWineProfile] = useState({});
  const [sparklingFlavor, setSparklingFlavor] = useState({});
  const [sparklingQR, setSparklingQR] = useState();
  const [sparklingIconIDS, setSparklingIconIDS] = useState([]);
  const [sparklingHeaderText, setSparklingHeaderText] = useState();
  const [sparklingBodyText, setSparklingBodyText] = useState();
  
  
  // Beer Data
  const [beerDataReady, setBeerDataReady] = useState(false);
  const [beerId, setBeerId] = useState();
  const [beerBitterness, setBeerBitterness] = useState();
  const [beerBody, setBeerBody] = useState();
  const [beerCarbonation, setBeerCarbonation] = useState();
  const [beerDryness, setBeerDryness] = useState();
  const [beerName, setBeerName] = useState();
  const [beerData, setBeerData] = useState();
  const [beerProfile, setBeerProfile] = useState({});
  const [beerProfileId, setBeerProfileId] = useState();
  const [beerOwner, setBeerOwner] = useState();
  const [userBeerFlavorData, setUserBeerFlavorData] = useState([]);
  const [beerSweetness, setBeerSweetness] = useState();
  const [beerQRData, setBeerQRData] = useState();
  const [beerTheme, setBeerTheme] = useState();
  const [beerIconIDS, setBeerIconIDS] = useState([]);



  // Fetch user's tasting profiles. 
  // Save states: wineID's and userFlavorChoiceIDS. ID's used to fetch flavor and wine data
  useEffect(() => {

    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get('id');

    const fetchTastingNotes = async () => {
      try {
        const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
        const authToken = process.env.REACT_APP_AUTH_TOKEN;
        
        const response = await fetch(`${apiEndpoint}/${id}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        console.log(data.data)
        setTastingType(data.data.tasting_type);
        if (data.data.tasting_type === 'beer') {
          setBeerDataReady(true);
        }
        setTastingNotes(data);
        setWineID(data.data.wine)
        setUserRelationalFlavorIDS(data.data.flavors)
        console.log(data.data.total_matched)
        setMatches(data.data.total_matched)



        // -------  SPARKLING DATA FETCHES  -------


        const effervescencePercentage = Math.round(data.data.effervescence * 100);
        setEffervescence(effervescencePercentage);

        //Sparkling User Selected Flavors
        if (data.data.flavors && data.data.flavors.length > 0) {
          const flavorEndpoint = process.env.REACT_APP_RELATIONAL_FLAVORS;
          const flavorIds = data.data.flavors.join(','); // join into comma-separated string

          const flavorResponse = await fetch(`${flavorEndpoint}${flavorIds}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json'
            }
        });

        if (!flavorResponse.ok) {
          throw new Error(`Flavor fetch failed. Status: ${flavorResponse.status}`);
        }

        const flavorData = await flavorResponse.json();
        console.log('sparkling flavor data:', flavorData);
        
        if (Array.isArray(flavorData.data)) {
          const flavorIdsArray = flavorData.data.map(item => item.Flavors_id);
          console.log('Extracted Flavors_id array:', flavorIdsArray);

          const flavorIdsString = flavorIdsArray.join(',');
          const flavorMainEndpoint = process.env.REACT_APP_FLAVORS + flavorIdsString;
          const flavorResponse = await fetch(`${flavorMainEndpoint}${flavorIdsString}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        });

        if (!flavorResponse.ok) {
          throw new Error(`Flavor fetch failed. Status: ${flavorResponse.status}`);
        }

        const flavorFinalData = await flavorResponse.json();
        console.log('Final flavor data:', flavorFinalData);
        setUserSparklingFlavor(flavorFinalData);
        }

        } else {
          console.warn('No flavors found in data.data.flavors. Skipping sparkling flavor fetch.');
        }

        // Sparkling Wine and Profile Fetches
        if(data.data.sparkling_wine) {
          console.log('Sparkling!')
          const sparklingEndpoint = process.env.REACT_APP_SPARKLING_ENDPOINT;

          const sparklingResponse = await fetch(`${sparklingEndpoint}${data.data.sparkling_wine}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json'
            }
          });

          if (!sparklingResponse.ok) {
            throw new Error(`HTTP error! Status: ${sparklingResponse.status}`);
          }

          const sparklingData = await sparklingResponse.json();
          console.log('Sparkling Data:', sparklingData);
          setSparklingData(sparklingData);
          setSparklingOwner(sparklingData.data.user_created);
          setSparklingTheme(sparklingData.data.theme);
          setSparklingHeaderText(sparklingData.data.title_font);
          setSparklingBodyText(sparklingData.data.body_font);

          // Fetch QR CODE for sparkling wine
          const sparklingQRIDS = sparklingData?.data?.QR_codes.join(',');
          if (sparklingData.data) {
            const sparklingQRResponse = await fetch(`${process.env.REACT_APP_RELATIONAL_QR_SPARKLING}${sparklingQRIDS}`, {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/json'
              }
            });

            if (!sparklingQRResponse.ok) {
              throw new Error(`HTTP error! Status: ${sparklingQRResponse.status}`);
            }

            const sparklingQRData = await sparklingQRResponse.json();
            const sparklingQRIDs = sparklingQRData?.data?.map(item => item.QR_Codes_id);
            const sparklingQRIDsString = sparklingQRIDs.join(',');
            
            const sparklingQRDataEndpoint = process.env.REACT_APP_QR + sparklingQRIDsString;
            const sparklingFinalQRResponse = await fetch(`${sparklingQRDataEndpoint}`, {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/json'
              }
            });

            if (!sparklingFinalQRResponse.ok) {
              throw new Error(`HTTP error! Status: ${sparklingFinalQRResponse.status}`);
            }

            const sparklingFinalQRData = await sparklingFinalQRResponse.json();
            console.log('Sparkling Final QR Data:', sparklingFinalQRData.data);
            setSparklingQR(sparklingFinalQRData);

            // Extract icon_ids from QR data
            const iconIDS = Array.isArray(sparklingFinalQRData.data)
              ? sparklingFinalQRData.data.map(item => item.icon)
              : [];

            const noIcons = iconIDS.some(icon => icon == null);

            if (noIcons) {
              setSparklingIconIDS(iconIDS);
              console.log("Some icon_ids were null/undefined. Stored directly:", iconIDS);
            } else {
              // Fetch full icon metadata
              // Fetch full icon metadata
              const qrIconEndpoint = process.env.REACT_APP_QR_ICON; // Should include `?filter[id][_in]=`
              const iconQueryParam = iconIDS.join(',');
              const iconURL = `${qrIconEndpoint}${iconQueryParam}`;

              const iconResponse = await fetch(iconURL, {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${authToken}`,
                  'Content-Type': 'application/json'
                }
              });

              if (!iconResponse.ok) {
                throw new Error(`HTTP error! Status: ${iconResponse.status}`);
              }

              const iconData = await iconResponse.json();
              const iconImageIDs = Array.isArray(iconData.data) ? iconData.data.map(item => item.icon) : [];
              console.log('Icon Data:', iconData);
              setSparklingIconIDS(iconImageIDs);
            }
          }

          // Sparkling Profile Fetch
          if (sparklingData.data){
          const sparklingProfileEndpoint = process.env.REACT_APP_SPARKLING_PROFILE;

          const sparklingProfileResponse = await fetch(`${sparklingProfileEndpoint}${sparklingData.data.sparkling_profile}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json'
            }
          });

          if (!sparklingProfileResponse.ok) {
            throw new Error(`HTTP error! Status: ${sparklingProfileResponse.status}`);
          }

          const sparklingProfileData = await sparklingProfileResponse.json();
          setSparklingWineProfile(sparklingProfileData); 
          const flavorSparkIds = sparklingProfileData?.data?.flavors?.map(item => item);
          const flavorIdsString = flavorSparkIds.join(',');
          console.log('Flavor IDs String:', flavorIdsString);

          // Fetch Sparkling Flavors
          const sparklingFlavorEndpoint = process.env.REACT_APP_RELATIONAL_SPARKLING_FLAVORS;

          const sparklingFlavorResponse = await fetch(`${sparklingFlavorEndpoint}${flavorIdsString}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json'
            }
          });

          if (!sparklingFlavorResponse.ok) {
            throw new Error(`HTTP error! Status: ${sparklingFlavorResponse.status}`);
          }

          const sparklingFlavorData = await sparklingFlavorResponse.json();
          console.log('Sparkling Flavor Data:', sparklingFlavorData);

          const sparklingFlavorIds = sparklingFlavorData.data.map(item => item.Sparkling_Flavors_id);
          const sparklingFlavorIdsString = sparklingFlavorIds.join(',');

          const sparklingFlavorMainEndpoint = process.env.REACT_APP_SPARKLING_FLAVORS + sparklingFlavorIdsString;

          const sparklingFlavorMainResponse = await fetch(`${sparklingFlavorMainEndpoint}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json'
            }
          });

          if (!sparklingFlavorMainResponse.ok) {
            throw new Error(`HTTP error! Status: ${sparklingFlavorMainResponse.status}`);
          }

          const sparklingFlavorMainData = await sparklingFlavorMainResponse.json();
          console.log('Sparkling Flavor Main Data:', sparklingFlavorMainData);
          setSparklingFlavor(sparklingFlavorMainData);
        }
      }





        //-----------  Beer Data Fetches ------------
        //Beer States
        const beerBody = Math.round(data.data.body * 100)
        const beerCarbonation = Math.round(data.data.carbonation * 100)
        
        setBeerId(data.data.beer);
        setBeerBitterness(data.data.bitter);
        setBeerBody(beerBody);
        setBeerCarbonation(beerCarbonation);
        setBeerDryness(data.data.dry);
        setBeerSweetness(data.data.sweet);
        
        console.log(data.data)
        // Fetch Beer Profile
        if (data.data.beer) {
          const beerProfileEndpoint = process.env.REACT_APP_BEER_PROFILE;

          const beerProfileResponse = await fetch(`${beerProfileEndpoint}${data.data.beer}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json'
            }
          }); 

          if (!beerProfileResponse.ok) {
            throw new Error(`HTTP error! Status: ${beerProfileResponse.status}`);
          }

          const beerProfileData = await beerProfileResponse.json();
          console.log('Beer Profile Data:', beerProfileData);
          setBeerProfile(beerProfileData);
        }

        console.log(data.data.flavors);
        // Fetch User Flavor Beer picks
        if (data.data.flavors && data.data.flavors.length > 0) {
          const flavorEndpoint = process.env.REACT_APP_RELATIONAL_FLAVORS;
          const flavorIds = data.data.flavors.join(','); // join into comma-separated string

          const flavorResponse = await fetch(`${flavorEndpoint}${flavorIds}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json'
          }
        });

        if (!flavorResponse.ok) {
          throw new Error(`Flavor fetch failed. Status: ${flavorResponse.status}`);
        }

        const flavorData = await flavorResponse.json();
        
        if (Array.isArray(flavorData.data)) {
          const flavorIdsArray = flavorData.data.map(item => item.Flavors_id);
          console.log('Extracted Flavors_id array:', flavorIdsArray);

          const flavorIdsString = flavorIdsArray.join(',');
          
          const flavorMainEndpoint = process.env.REACT_APP_FLAVORS + flavorIdsString;
          
          const flavorResponse = await fetch(`${flavorMainEndpoint}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        });

        if (!flavorResponse.ok) {
          throw new Error(`Flavor fetch failed. Status: ${flavorResponse.status}`);
        }

        const flavorFinalData = await flavorResponse.json();
        console.log('Final flavor data:', flavorFinalData);
        setUserBeerFlavorData(flavorFinalData);
        }

        } else {
          console.warn('No flavors found in data.data.flavors. Skipping flavor fetch.');
        }

    

        // Fetch beer data if beer ID exists
        if (data.data.beer) {
        const beerResponse = await fetch(`${process.env.REACT_APP_BEER_ENDPOINT}${data.data.beer}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        });

        if (!beerResponse.ok) throw new Error(`HTTP error! Status: ${beerResponse.status}`);

        const fetchedBeerData = await beerResponse.json();
        setBeerData(fetchedBeerData);
        setBeerOwner(fetchedBeerData.data.user_created);
        setBeerTheme(fetchedBeerData.data.theme);

        // Fetch QR code data
        const beerQRIDS= fetchedBeerData?.data?.QR_codes.join(',');
  
        if (fetchedBeerData.data) {
          const qrCodeEndpoint = process.env.REACT_APP_RELATIONAL_BEER_QR;
          const authToken = process.env.REACT_APP_AUTH_TOKEN;

          const response = await fetch(`${qrCodeEndpoint}${beerQRIDS}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json'
            }
          });

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const qrCodeData = await response.json();
          const beerQRIDs = qrCodeData?.data?.map(item => item.QR_Codes_id) || [];
          const beerQRIDsString = beerQRIDs.join(',');
          console.log('Beer QR Code ID:', beerQRIDsString);

          if(qrCodeData?.data && qrCodeData.data.length > 0) {

            const authToken = process.env.REACT_APP_AUTH_TOKEN;
            const QREndpoint= process.env.REACT_APP_QR + beerQRIDsString;
            
            const qrResponse = await fetch(QREndpoint, {
              method: 'GET',
              headers: { 
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/json'       
              }
            });

            if (!qrResponse.ok) {
              throw new Error(`QR Code fetch failed. Status: ${qrResponse.status}`);
            }

            const beerQrData = await qrResponse.json();
            setBeerQRData(beerQrData);
            console.log('Beer QR Code Data:', beerQrData);
          }
          
        }
      }
        //User sweetness and acidity
        const userSweetnessPercentage = Math.round(data.data.sweetness * 100)
        const userAcidPercentage = Math.round(data.data.acidity * 100)
        setUserAcidity(userAcidPercentage)
        setUserSweetness(userSweetnessPercentage)
      

        //Get matched text
        const matchResponse = await fetch(process.env.REACT_APP_MATCH_TEXT, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        });

        if (!matchResponse.ok) {
          throw new Error(`HTTP error! Status: ${matchResponse.status}`);
        }

        // 3 different texts depending if the user matched 1, 2, or 3 notes. 
        const matchData = await matchResponse.json();
        setTastingText(matchData.data[0])
        

        setLoading(false);
      } catch (error) {
        console.error('Error fetching tasting notes:', error);
        setError(error.message);
        setLoading(false);
      }
    };
    fetchTastingNotes();
  }, []); // Empty dependency array means this effect runs once on mount




  useEffect(() => {
    const fetchWineData = async () => {
      if (!wineID) return;

      setWineLoading(true);
      try {
        const winesEndpoint = process.env.REACT_APP_WINES_ENDPOINT;
        const authToken = process.env.REACT_APP_AUTH_TOKEN;
        const url =  `${winesEndpoint}${wineID}`;

        const response = await fetch(url, {
          method: 'GET',
          headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json'
          }
        });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data)

      const qrCodesRelID = data.data.QR_codes
      setWineData(data);
      setWineProfileID(data.data.wine_profile);
      setRelationalQrIDS(data.data.QR_codes);
      setTheme(data.data.theme);
      setHeaderText(data.data.title_font);
      setBodyText(data.data.body_font);

      const owner = data.data.user_created;

      if (owner) {
          const ownerEndpoint = process.env.REACT_APP_OWNER
          const ownerData = await fetch(ownerEndpoint, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json'
            }
          });

          if (!ownerData.ok) {
            throw new Error(`HTTP error! Status: ${ownerData.status}`);
          }

          const ownerItems = await ownerData.json()
          const currentOwner = ownerItems.data.find(item => item.user_created === owner);
          const logo = currentOwner.logo
          console.log(currentOwner)
          setWineryLogo(logo)
        }

        if (qrCodesRelID && qrCodesRelID.length > 0) {
          console.log('true')

          const relQrEndpoint = process.env.REACT_APP_RELATIONAL_QR;
          const ids = qrCodesRelID.join(',')
          const qrResponse = await fetch(`${relQrEndpoint}${ids}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json'
            }
          });

          if (!qrResponse.ok) {
            throw new Error(`Flavors HTTP error! Status: ${qrResponse.status}`);
          }

          const qrData = await qrResponse.json();
          const idArray = qrData.data.map(item => item.QR_Codes_id);
          const qrDataEndpoint = process.env.REACT_APP_QR + idArray

          const qrDataResponse = await fetch(`${qrDataEndpoint}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json'
            }
          })

          if (!qrDataResponse.ok) {
            throw new Error(`Flavors HTTP error! Status: ${qrDataResponse.status}`);
          }

          const finalQRData = await qrDataResponse.json()
          setQRData(finalQRData)

          // Extract icon_ids from QR data
          const icon_ids = Array.isArray(finalQRData.data)
            ? finalQRData.data.map(item => item.icon)
            : [];

          console.log("Extracted icon_ids:", icon_ids);

          const hasMissingIcons = icon_ids.some(icon => icon == null);

          if (hasMissingIcons) {
            setIconQRIMGID(icon_ids);
            console.log("Some icon_ids were null/undefined. Stored directly:", icon_ids);
          } else {
            // Fetch full icon metadata
            const qrIconEndpoint = process.env.REACT_APP_QR_ICON; // Should include `?filter[id][_in]=`
            const iconQueryParam = icon_ids.join(',');
            const iconURL = `${qrIconEndpoint}${iconQueryParam}`;

            console.log("Fetching icons from:", iconURL);

            const iconResponse = await fetch(iconURL, {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/json'
              }
            });

            if (!iconResponse.ok) {
              throw new Error(`Icon fetch error! Status: ${iconResponse.status}`);
            }

            const iconData = await iconResponse.json();
            const iconImageIDs = Array.isArray(iconData.data) ? iconData.data.map(item => item.icon) : [];

            setIconQRIMGID(iconImageIDs);
            console.log("Fetched icon image UUIDs:", iconImageIDs);
          }
        }

        // Second fetch for flavors data
        if (userRelationalFlavorIDS && userRelationalFlavorIDS.length > 0) {
          const flavorsEndpoint = process.env.REACT_APP_RELATIONAL_FLAVORS;
          const flavorIds = userRelationalFlavorIDS.join(',');

          const flavorsResponse = await fetch(`${flavorsEndpoint}${flavorIds}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json'
            }
          });

          if (!flavorsResponse.ok) {
            throw new Error(`Flavors HTTP error! Status: ${flavorsResponse.status}`);
          }

          const flavorsData = await flavorsResponse.json();
          setRelationalFlavorsData(flavorsData);
          const flavorIDsArray = flavorsData.data.map(item => item.Flavors_id);
          setUserFlavorIDS(flavorIDsArray);

          // Third fetch using extracted Flavors_id values
          const flavorsMainEndpoint = process.env.REACT_APP_FLAVORS;
          const flavorsIDsString = flavorIDsArray.join(',');

          const mainFlavorsResponse = await fetch(`${flavorsMainEndpoint}${flavorsIDsString}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json'
            }
          });

          if (!mainFlavorsResponse.ok) {
            throw new Error(`Main Flavors HTTP error! Status: ${mainFlavorsResponse.status}`);
          }

          const mainFlavorsData = await mainFlavorsResponse.json();
          setUserFlavorData(mainFlavorsData);
        }

        setWineLoading(false);
      } catch (error) {
        console.error('Error fetching wine data:', error);
        setError(error.message);
        setWineLoading(false);
      }
    };

    fetchWineData();
  }, [wineID, userRelationalFlavorIDS]);



  // Fetch wine profile
  useEffect(() => {
    const fetchWineData = async () => {
      if (!wineProfileID) return;

      setWineLoading(true);
      try {
        const wineProfileEndpoint = process.env.REACT_APP_WINE_PROFILE;
        const authToken = process.env.REACT_APP_AUTH_TOKEN;
        const response = await fetch(`${wineProfileEndpoint}${wineProfileID}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setWineProfileData(data);
        const wineSweetnessPercentage = Math.round(data.data.sweetness * 100)
        const wineAcidPercentage = Math.round(data.data.acidity * 100)
        setWineAcidity(wineAcidPercentage)
        setWineSweetness(wineSweetnessPercentage)
        const flavorIDs = data.data.flavors;

        if (Array.isArray(flavorIDs) && flavorIDs.length > 0) {
          const flavorString = flavorIDs.join(',');
          const flavorProfileEndpoint = process.env.REACT_APP_WINE_PROFILES_WINE_FLAVORS + flavorString;
          const flavorResponse = await fetch(`${flavorProfileEndpoint}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json'
            }
          });

          if (!flavorResponse.ok) {
            throw new Error(`Flavor HTTP error! Status: ${flavorResponse.status}`);
          }

          const relFlavorData = await flavorResponse.json();

          if (Array.isArray(relFlavorData.data) && relFlavorData.data.length > 0) {
            const flaveIDArray = relFlavorData.data.map(item => item.Wine_Flavors_id);
            const flaveIDString = flaveIDArray.join(',')
            const finalFlaveEndpoint = process.env.REACT_APP_WINE_FLAVORS + flaveIDString

            const finalFlaveResponse = await fetch(finalFlaveEndpoint, {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/json'
              }
            });

            if (!finalFlaveResponse.ok) {
              throw new Error(`Flavor HTTP error! Status: ${finalFlaveResponse.status}`)
            }

            const flavorData = await finalFlaveResponse.json()
            setWineFlavors(flavorData)
          }

        }

        setWineLoading(false);
      } catch (error) {
        console.error('Error fetching wine data:', error);
        setError(error.message);
        setWineLoading(false);
      }
    };

    fetchWineData();
  }, [wineProfileID]);

  // Get the current URL with the ID parameter
  const currentUrl = window.location.href;

  // Extract the ID from URL for sharing
  const queryParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    const isLoading = !tastingNotes.data || !wineData.data || !userFlavorData.data || !wineFlavors.data || !tastingText;

    // When content loads, set invisible first, then fade in
    if (!isLoading && isJustLoaded) {
      setIsJustLoaded(false);
    }
  }, [tastingNotes.data, wineData.data, userFlavorData.data, wineFlavors.data, tastingText]);

  useEffect(() => {
    if (menuOpen) {
      setShouldRender(true); // make visible immediately
    } else {
      // wait for fade-out before unmounting
      const timeout = setTimeout(() => setShouldRender(false), 300); // match your CSS duration
      return () => clearTimeout(timeout);
    }
  }, [menuOpen]);


  const isLoading = !tastingNotes?.data ||
        !wineData?.data ||
        !userFlavorData?.data ||
        !wineFlavors?.data ||
        !tastingText;
  const beerLoading = !beerData || !beerName || beerBitterness == null;

  const fontMapReg = {
    0: 'Cormorant-Reg',
    1: 'Garamond-Reg',
    2: 'Helvetica-Reg',
    3: 'Raleway-Reg'
  }
  const fontMapBold = {
    0: 'Cormorant-Bold',
    1: 'Garamond-Bold',
    2: 'Helvetica-Bold',
    3: 'Raleway-Bold'
  }
  const lightColor = {
    1: '#FFFBF1',
    2: '#FFFBF1',
    3: '#FFF8F8', 
    4: '#FFF8F8', 
    5: '#FFFBF1'
  }
  const darkColor = {
    1: '#FFF7E4',
    2: '#FFF7E4',
    3: '#F8E9E9', 
    4: '#F8E9E9', 
    5: '#FFF7E4'
  }
  const barColor = { 1: '#F8EBA9', 2: '#860000', 3: '#FFC9C1', 4: '#FFC9C1', 5: '#F8EBA9', 6: '#FBBD14' }
  

  return (
    <div className="App">
      {isLoading && !tastingType && !beerData && !beerOwner ?  (
        <div className='loading-screen'>
          <div>
            <img className='loading-spinner' alt='Sensory Dining Logo' src='https://cdn.prod.website-files.com/66bcf3aaed16d1b483d25f8f/66c8d5467dbaeaea41684fc0_webclip.png'></img>
          </div>
        </div>
      ) : (
        <div>
          {tastingType === 'beer' ? (
          <Beer 
            isJustLoaded={isJustLoaded} shouldRender={shouldRender} menuOpen={menuOpen} theme={theme} 
            setMenuOpen={setMenuOpen} darkColor={darkColor} fontMapBold={fontMapBold} headerText={headerText} 
            wineData={wineData} fontMapReg={fontMapReg} bodyText={bodyText} imageBase={imageBase} imageType={imageType} 
            matches={matches} tastingText={tastingText} userFlavorData={userFlavorData} userAcidity={userAcidity} 
            barColor={barColor} userSweetness={userSweetness} lightColor={lightColor} qrData={qrData} iconQRIMGID={iconQRIMGID} QR={QR}
            Share={Share} wineAcidity={wineAcidity} wineSweetness={wineSweetness} beerData={beerData} beerOwner={beerOwner} userBeerFlavorData={userBeerFlavorData}  
            beerProfile={beerProfile} beerCarbonation={beerCarbonation} beerBody={beerBody} beerBitterness={beerBitterness} beerSweetness={beerSweetness}
            beerDryness={beerDryness} beerQRData={beerQRData} sparklingTheme={sparklingTheme} beerTheme={beerTheme}
          />
        ) : tastingType === 'sparkling' ? (
          <Sparkling 
            isJustLoaded={isJustLoaded} shouldRender={shouldRender} menuOpen={menuOpen} theme={theme} 
            setMenuOpen={setMenuOpen} darkColor={darkColor} fontMapBold={fontMapBold} headerText={headerText} 
            wineData={wineData} fontMapReg={fontMapReg} bodyText={bodyText} imageBase={imageBase} imageType={imageType} 
            matches={matches} tastingText={tastingText} userFlavorData={userFlavorData} userAcidity={userAcidity} 
            barColor={barColor} userSweetness={userSweetness} lightColor={lightColor} qrData={qrData} iconQRIMGID={iconQRIMGID} QR={QR}
            Share={Share} sparklingData={sparklingData} sparklingOwner={sparklingOwner} sparklingTheme={sparklingTheme} userSparklingFlavor={userSparklingFlavor}
            effervescence={effervescence} sparklingWineProfile={sparklingWineProfile} sparklingFlavor={sparklingFlavor} sparklingQR={sparklingQR}
            sparklingIconIDS={sparklingIconIDS} sparklingHeaderText={sparklingHeaderText} sparklingBodyText={sparklingBodyText} 
          />
        ) : (tastingType === 'wine' || tastingType == null) ? (
          <Wine 
            isJustLoaded={isJustLoaded} shouldRender={shouldRender} menuOpen={menuOpen} theme={theme} 
            setMenuOpen={setMenuOpen} darkColor={darkColor} fontMapBold={fontMapBold} headerText={headerText} 
            wineData={wineData} fontMapReg={fontMapReg} bodyText={bodyText} imageBase={imageBase} imageType={imageType} 
            wineryLogo={wineryLogo} matches={matches} tastingText={tastingText} userFlavorData={userFlavorData} userAcidity={userAcidity} 
            barColor={barColor} userSweetness={userSweetness} lightColor={lightColor} wineProfileData={wineProfileData} wineFlavors={wineFlavors} qrData={qrData} iconQRIMGID={iconQRIMGID} QR={QR}
            Share={Share} wineAcidity={wineAcidity} wineSweetness={wineSweetness} beerData={beerData}
          />
        ) : null}
        <Footer theme={theme} sparklingTheme={sparklingTheme} beerTheme={beerTheme} />
      </div>
    )}
    </div>
  );
}

export default App;
